import React from 'react'
import { MissInfoSmile, Spinner } from 'media/icons'
import { useTranslation } from 'react-i18next'
import { StyledPreparedMessage } from './styled'

// This component showing to the user different loading, empty and error states when trying to prepare data

const PreparedMessage = ({ type }) => {
	const [t] = useTranslation()

	let text
	// variants for type: error, noData
	if(type === 'error') {
		text = t('dashboard_section.error')
	}else{
		text = t('dashboard_section.data_not_found')
	}

	return(
		<StyledPreparedMessage className='dchart__no_data'>
			<div className='dchart__no_data__icon_text'>
				{type === 'loading' ?
					<Spinner /> :
					< MissInfoSmile className='miss_info_smile' />}
				{type !== 'loading' && <span>{text}</span>}
			</div>
		</StyledPreparedMessage>
	)
}

export default PreparedMessage
